import React, { Component } from 'react';
import P5Wrapper from 'react-p5-wrapper';

import sketch from './sketch';
// import soundFile from '../../../assets/musics/BeatTrap.mp3'

export default class ArtExampleP5 extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <P5Wrapper sketch={sketch} />
        )
    }

}
